import React from 'react';
import { View, StyleSheet, Text, TouchableOpacity } from 'react-native';
import { Avatar, Heading, HeadingTypes } from '../../components';
import { defaultScale } from '../../utils/scaling';
import Theme from '../../theme';

const PartnerCard = ({ t, partner, handelInvite, isLoading,
  renderInviteStatus = true, selectedPartner, containerStyle }) => {
  const isSelectedRow = selectedPartner && partner.uid === selectedPartner.uid;
  const isPartnerAvailable = partner.available && partner.eligable;
  return (
    <TouchableOpacity
      disabled={!isPartnerAvailable || !renderInviteStatus}
      onPress={() => handelInvite(partner)}
      style={[styles.container, isSelectedRow ? styles.selectedContainer: {}, containerStyle]}>
      <View style={styles.profileContainer}>
        <Avatar
          avatarId={partner.uid}
          iconColor={partner.available && partner.eligable
            ? isSelectedRow ? Theme.WHITE : Theme.CHARCOAL
            : Theme.GREY_MEDIUM
          }
          customStyle={{
            justifyContent:'center',
            width: defaultScale(38),
            height: defaultScale(38),
            borderWidth: 1,
            borderColor: Theme.GREY_LIGHT,
            marginRight: defaultScale(14),
          }}
        />
        <View style={styles.profileDetailsContainer}>
          <View style={{ flexDirection: 'row', justifyContent: 'center' }}>
            <Text
              style={[
                Theme.textStyle.bodyCopyReg,
                partner.available && partner.eligable
                ? isSelectedRow ? styles.selectedFullname : styles.fullname
                : styles.fullnameUnavailable
              ]}
            >{partner.fullname}</Text>
          </View>
          <Text
            style={[
              Theme.textStyle.bodyCopyReg,
              partner.available && partner.eligable
                ? isSelectedRow ? styles.selectedNickname : styles.nickname
                : styles.nicknameUnavailable
            ]}
          >{partner.nickname &&  ` (${partner.nickname})`}</Text>
        </View>
      </View>
      <View style={styles.inviteContainer}>
        {renderInviteStatus &&
          <PartnerInviteAvailableStatus
            t={t}
            partner={partner}
            isLoading={isLoading}
            handelInvite={handelInvite}
          />
        }
      </View>
    </TouchableOpacity>
  )
};

export const PartnerInviteAvailableStatus = ({ t, partner, isLoading, handelInvite }) => (
  <>
    {
      !partner.available ?
        <Heading
          title={t('unavailable')}
          style={styles.unavailableText}
          headerType={HeadingTypes.HEADING_THREE}
        />
        : !partner.eligable
          ?
          <Heading
            title={t('incompatibleMembership')}
            style={styles.unavailableText}
            headerType={HeadingTypes.HEADING_THREE}
          />
          :
          <></>
    }
  </ >
)

const styles = StyleSheet.create({
  container: {
    borderTopWidth: 2,
    paddingTop: 10,
    paddingBottom: 10,
    flexDirection: 'row',
    alignItems: 'center',
    alignContent: 'center',
    justifyContent: 'center',
    paddingHorizontal: 10,
    borderTopColor: Theme.GREY_LIGHT,
  },
  selectedContainer: {
    backgroundColor: Theme.GREY_DARK,
  },
  profileContainer: {
    flex: 0.6,
    flexDirection: 'row',
  },
  profileDetailsContainer: {
    paddingRight: 10,
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap:'wrap',
  },
  inviteContainer: {
    flex: 0.4,
    fontFamily: Theme.CustomBold,
    alignItems: 'flex-end',
  },
  fullname: {
    color: Theme.CHARCOAL,
  },
  selectedFullname: {
    color: Theme.WHITE,
  },
  fullnameUnavailable: {
    color: Theme.GREY,
  },
  nickname: {
    fontFamily: Theme.CustomNormalItalic,
    color: Theme.GREY_MEDIUM,
  },
  selectedNickname: {
    fontFamily: Theme.CustomNormalItalic,
    color: Theme.WHITE,
  },
  nicknameUnavailable: {
    fontFamily: Theme.CustomNormalItalic,
    color: Theme.GREY,
  },
  inviteText: {
    fontFamily: Theme.CustomBold,
    color: Theme.PRIMARY,
    textAlign: 'right',
  },
  unavailableText: {
    color: Theme.GREY,
    fontFamily: Theme.CustomNormalItalic,
    textAlign: 'right',
  },
});

export default PartnerCard;
